// extracted by mini-css-extract-plugin
module.exports = {"MobileCenter":"SectionHeader_MobileCenter__UzLy3","RowMobileCenter":"SectionHeader_RowMobileCenter__4GoL4"};